// extracted by mini-css-extract-plugin
export var banner = "_p4-0";
export var settingRow = "_p4-2";
export var titleIcon = "_p4-1";